import React from 'react'

export default function BrowseChannelIcon() {
  return (
    <svg viewBox="0 0 20 20" >
        <path fill='currentColor' d="M6.985 3.897a.75.75 0 0 0-1.47-.294L4.935 6.5H2.75a.75.75 0 0 0 0 1.5h1.885l-.8 4H1.75a.75.75 0 0 0 0 1.5h1.785l-.52 2.603a.75.75 0 1 0 1.47.294l.58-2.897h2.47l-.52 2.603a.75.75 0 1 0 1.47.294l.58-2.897h2.185a.75.75 0 0 0 0-1.5H9.365l.07-.353a.75.75 0 1 0-1.47-.294l-.13.647h-2.47l.8-4h.585a.75.75 0 0 0 0-1.5h-.285l.52-2.603ZM13 4.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM9 7a4 4 0 1 1 7.309 2.248l1.471 1.472a.75.75 0 1 1-1.06 1.06l-1.472-1.471A4 4 0 0 1 9 7Z" ></path>
    </svg>
  )
}
